export interface IRecordEducationListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
}

export class RecordEducationListItem implements IRecordEducationListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;

    constructor();
    constructor(obj: IRecordEducationListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
    }
}